module.exports = {
    message: {
        // 首页
        navigator_website: 'Website',
        navigator_collect: 'Collect',
        navigator_service: 'CS',
        navigator_teach: 'Guide',
        navigator_logout: 'Sign out',
        navigator_mobile_logout: 'Mobile Login',
        navigator_email_logout: 'Email',
        navigator_download: 'Download',
        // 登录、注册页
        navigator_signIn: 'Register',
        navigator_lang: 'Sign in',
        navigator_email: 'Email',
        input_account: 'Enter Account',
        input_mobile: 'Enter Phone Number',
        input_password: 'Enter Password',
        input_password_again: 'Confirm Password',
        input_email_address: 'Enter Email',
        input_reset_email: 'Enter Account/Email that needs to reset password',
        input_reset_password: ', reset password by the following verification methods',
        retrieve_password: 'Retrieve Password',
        forget_password: 'Forget Password',
        next_step: 'Next',
        bind_email: 'Bind Email',
        input_bind_email: 'Enter the bound Email account',
        bound_email: 'Email Bound',
        enter_code: 'Verification Code',
        get_code: 'Get Code',
        get_code_seconds: 's',
        security_verification: 'Safety Verification',
        inputTheAnswer: 'Enter Verification Code',
        noneSelectArea: "Select Area Code",
        confirm: 'Confirm',
        bind: 'Bind',
        agree: 'Read and Agree',
        tips_1: 'Unregistered number will be registered and signed in after verification',
        copy_success: 'Copy successfully!',
        copy_fail: 'Please copy manually',
        incorrect_email: 'Please enter the correct Email address!',
        emailTips1: 'Password cannot contain space or Chinese characters!',
        emailTips2: 'Password must contain 6 digits at least',
        emailTips3: 'The two passwords you entered do not match',
        emailTips4: 'Incorrect verification code',
        emailTips5: 'Please enter a 4-12 account name with a combination of letters and numbers',
        emailTips6: 'Please enter a password with a combination of 6~20 alphanumeric characters and non-Chinese special characters',
        emailTips7: 'The two passwords you entered do not match',
        selectAreaCode: 'Area Code',
        urlError: 'The current access address is wrong!',
        ThreeTips: 'Reminder',
        verifiedTips1:'Users must be at least 18 years old to access this game.',
        verifiedTips2:'Login failed, please complete identity verification to play the game',
        // 底部
        rules_clause: 'Privacy Commitment',
        privacy_clause: 'Terms of Use',
        service_email: 'Customer Service Email:',
        EmailAddress: 'maplestoryr.sea@gmail.com',
        // 教程页
        infoTitle: 'PC Login and Top up Instruction'
    }
}